import React from 'react';
import { motion } from 'framer-motion';
// import { useTheme } from '../components/ThemeWrapper';
import ModernDisciplinePanel from '../components/DigitalDiscipline/ModernDisciplinePanel';
import { useUI } from '../contexts/UIContext';

/**
 * DigitalDisciplineScreen Component
 * 
 * This screen serves as the main entry point for the Digital Discipline feature.
 * It wraps the DigitalDisciplinePanel component and provides theme context.
 */
const DigitalDisciplineScreen = ({ navigateToScreen, showXPNotification }) => {
  // Use UIContext for theme to ensure sync with Settings
  const { isDarkMode, navigateToScreen: ctxNavigate } = useUI();
  const effectiveNavigate = navigateToScreen || ctxNavigate;

  return (
    <div className={`relative min-h-screen ${
      isDarkMode
        ? 'bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950'
        : 'bg-gradient-to-br from-slate-50 via-white to-slate-50'
    }`}>
      {/* Subtle animated background blobs for depth (pointer-events-none so it doesn't block UI) */}
      <motion.div
        aria-hidden
        className="pointer-events-none absolute -top-24 -left-24 h-96 w-96 rounded-full blur-3xl"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: isDarkMode ? 0.15 : 0.25, scale: 1 }}
        transition={{ duration: 1.2, ease: 'easeOut' }}
        style={{
          background: isDarkMode
            ? 'radial-gradient(closest-side, rgba(16,185,129,0.35), rgba(0,0,0,0))'
            : 'radial-gradient(closest-side, rgba(16,185,129,0.25), rgba(255,255,255,0))'
        }}
      />
      <motion.div
        aria-hidden
        className="pointer-events-none absolute -bottom-28 -right-24 h-[28rem] w-[28rem] rounded-full blur-3xl"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: isDarkMode ? 0.12 : 0.2, scale: 1 }}
        transition={{ duration: 1.4, ease: 'easeOut', delay: 0.1 }}
        style={{
          background: isDarkMode
            ? 'radial-gradient(closest-side, rgba(20,184,166,0.3), rgba(0,0,0,0))'
            : 'radial-gradient(closest-side, rgba(20,184,166,0.2), rgba(255,255,255,0))'
        }}
      />

      {/* Fade-in wrapper for a softer entrance */}
      <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.35 }}>
        <ModernDisciplinePanel
          isDarkMode={isDarkMode}
          navigateToScreen={effectiveNavigate}
          showXPNotification={showXPNotification}
        />
      </motion.div>
    </div>
  );
};

export default DigitalDisciplineScreen;